import React, { useState } from "react";
import { Notyf } from "notyf";
import { Switch } from "@material-ui/core";

// Components
import Loader from "~/components/Loader";
// Utils
import { updateTerminal } from "~/api/terminal";

const Printer = (props) => {
  const notyf = new Notyf({
    position: {
      x: "right",
      y: "top",
    },
    duration: 3000,
    dismissible: true,
  });

  const [load, setLoad] = useState(false);
  const store = props.store;
  const terminal = props.terminal;
  const {
    printer: { enable },
    minTicket,
  } = props.terminal.config;
  const [printerEnable, setPrinterEnable] = useState(enable);
  const [minTicketEnable, setMinTicketEnable] = useState(minTicket);

  const updateConfig = async (e) => {
    e.preventDefault();
    setLoad(true);

    const config = {
      ...terminal.config,
      printer: {
        ...terminal.config.printer,
        enable: printerEnable,
      },
      minTicket: minTicketEnable,
    };

    try {
      const res = await updateTerminal(store._id, {
        config,
      });
      if (res.status === 200) {
        notyf.success("Success");
        setLoad(false);
        props.setTerminal({ ...terminal, config });
      }
    } catch (error) {
      setLoad(false);
      notyf.error("Erreur");
    }
  };

  return (
    <div className="container">
      {load ? (
        <Loader />
      ) : (
        <div className="row gx-5 justify-content-between page-type-commande">
          <div className="col">
            <div className="block-styled">
              <h1 className="text-center block-styled-head">Impression</h1>
              <div className="borne">
                <div className="row gx-5 btns-toggle justify-content-between">
                  <div className="col">
                    <div className="input mt-3">
                      <Switch
                        onChange={(e) => setPrinterEnable(!printerEnable)}
                        checked={printerEnable}
                        color="primary"
                        name="printerEnable"
                        inputProps={{ "aria-label": "primary checkbox" }}
                      />
                      Imprimer le ticket
                    </div>
                    <div className="input mt-3">
                      <Switch
                        onChange={(e) => setMinTicketEnable(!minTicketEnable)}
                        checked={minTicketEnable}
                        color="primary"
                        name="minTicketEnable"
                        inputProps={{ "aria-label": "primary checkbox" }}
                      />
                      Imprimer le minimum sur le ticket payer en espece
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-center styles--top">
                <button type="button" onClick={updateConfig}>
                  Validez
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Printer;
